import { regiones, comunas } from 'happ-preloaded-data/data';

const communesByReg = region => {
    const id = getIdRegBayName(region);
    if ( id !== null ) {
        return comunas.filter(comuna => comuna.reg === id);
    } 
    return null;   
}

const getIdRegBayName = region => {
    if ( region ) {
        let id = 0;
        regiones.some(reg => {
            if (reg.name === region) {
                id = reg.id;
            }
        })
        return id;
    }
    return null;
}

export {
    regiones,
    communesByReg
}